module.exports = __webpack_public_path__ + "img/contact.705cbf57.png";